// extracted by mini-css-extract-plugin
export default {"container":"Setting_container__YydEf","contentRow":"Setting_contentRow__FzLlb","info":"Setting_info__7eBC7","content":"Setting_content__ETnrn"};